<template>
  <div>
    <div class="mb-10" id="container"></div>
    <div class="text-center text-default">Allocation summary</div>
  </div>
</template>
<script>
import moment from 'moment'
import { Chart } from '@antv/g2'

export default {
  // name: 'LoadPattern',
  props: ['auction', 'orders'],
  data: function () {
    return {
      color: [
        {
          area: '#2fc25b',
          line: '#1890ff',
        },
        {
          area: '#1fc29b',
          line: '#2978ff',
        },
      ],
      chart: null,
    }
  },
  methods: {
    moment,
    drawPatternChart() {
      if (!this.orders.length || !this.auction) {
        return
      }

      if (this.chart) {
        this.chart.destroy()
      }

      const chartData = []

      var auction = this.auction

      const sortedOrders = [...this.orders].sort(function (a, b) {
        if (a.price > b.price) {
          return auction.flow == 'sell' ? 1 : -1
        }
        if (a.price < b.price) {
          return auction.flow == 'sell' ? -1 : 1
        }
        if (a.price == b.price) {
          return 0
        }
      })

      var totalVolume = 0
      const participants = {}
      var maxAuctionVolume = parseFloat(auction.allocationVolume)
      var maxPrice = 0

      var receivedOrderQuantity = 0
      for (var order of this.orders) {
        // console.log(order.quantity)
        // console.log('order', order)
        maxPrice = maxPrice < order.price ? order.price : maxPrice
        receivedOrderQuantity += order.quantity
      }
      // console.log('Max', maxAuctionVolume)
      // console.log('Quantity', receivedOrderQuantity)

      for (var order of sortedOrders) {
        for (var i = totalVolume; i <= totalVolume + order.quantity; i++) {
          var acceptedVolume =
            order.quantity + totalVolume > maxAuctionVolume
              ? maxAuctionVolume - totalVolume || 0
              : order.quantity

          // if we exceeded order quantity just return

          // if (i > totalVolume + order.quantity) {
          //   return
          // }

          var tick = {
            volume: i,
            accepted: acceptedVolume,
            price: order.price,
            title: order.participantName,
            overflow: order.quantity - acceptedVolume,
            color: '#fc8844',
          }

          tick[order.participantName] = order.price
          if (!participants[order.participantName]) {
            participants[order.participantName] = {
              min: 0,
              max: Math.floor(maxPrice) + 1,
            }
          }

          chartData.push(tick)
        }
        totalVolume += order.quantity
      }

      console.log(chartData)

      const chart = new Chart({
        container: 'container',
        autoFit: true,
        height: 220,
      })

      chart.data(chartData)
      chart.scale(participants)

      var colorSwitcher = 0
      for (const [key, value] of Object.entries(participants)) {
        chart
          .line()
          .position('volume*' + key)
          .color(this.color[colorSwitcher].line)
        chart
          .area()
          .position('volume*' + key)
          .color(this.color[colorSwitcher].area)

        colorSwitcher = colorSwitcher == 0 ? 1 : 0
      }

      if (receivedOrderQuantity >= maxAuctionVolume) {
        chart.annotation().region({
          top: true,
          start: [maxAuctionVolume, 'min'],
          end: ['max', 'max'],
          style: {
            fill: '#f5222d',
          },
        })
      }

      chart.annotation().dataMarker({
        top: true,
        position: [auction.allocationVolume, maxPrice],
        line: {
          length: 30,
        },
        text: {
          content: 'Auction Volume ' + auction.allocationVolume + ' MWh/h',
          style: {
            textAlign: 'right',
          },
        },
      })

      chart.tooltip({
        showTitle: false,
        crosshairs: 'y',
        // customContent: (title, data) => {
        //   console.log(title)
        //   // var volumeAccepted =
        //   //   title +
        //   //   (data[0].accepted > 0
        //   //     ? ' Accepted: ' + data.accepted + ' MWh/h'
        //   //     : '')

        //   return `<div>${title}</div>`
        // },
        // return (
        // )
      })

      chart.render()

      this.chart = chart
    },
  },
  computed: {},
  beforeCreate() {},
  watch: {
    orders: {
      handler(newVal, oldVal) {
        if (newVal.length != oldVal.length)
          // console.log(newVal.length != oldVal.length)
          // console.log(oldVal)
          this.drawPatternChart()
      },
      deep: true,
    },
  },
  mounted() {
    // this.drawPatternChart()
  },
}
</script>

<style>
[data-kit-theme='default'] .ant-table-thead > tr > th,
[data-kit-theme='default'] .ant-table-tbody > tr > td {
  padding: 4px 8px;
}

.ant-col.ant-form-item-label {
  padding-bottom: 0px;
}
.ant-col.ant-form-item-label label {
  margin-bottom: 0px;
}
</style>
